import { Navigate, RouteObject } from 'react-router-dom';

import {
  AuthLayout,
  ForgetPassword,
  Login,
  NewAccount,
  InvalidInvitation,
  NewPassword,
} from '../modules/auth';

export const nonAuthRoutes: RouteObject[] = [
  {
    element: <AuthLayout />,
    children: [
      {
        index: true,
        path: 'login',
        element: <Login />,
      },
      {
        path: 'forget-password',
        element: <ForgetPassword />,
      },
      {
        path: 'new-account/:token',
        element: <NewAccount />,
      },
      {
        path: 'invalid-invitation',
        element: <InvalidInvitation />,
      },
      {
        path: 'new-password',
        element: <NewPassword />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/login" />,
  },
];
